import React from 'react'
import styled from '@emotion/styled'
import { fontSize, fontWeight, lineHeight, device, color, SmallText } from '@ticketswap/solar'
import Price from '~/components/Price'

const Pricing = styled.strong`
  display: block;
  text-align: right;
  color: ${color.space};
  font-size: ${fontSize[16]};
  font-weight: ${fontWeight.semiBold};
  line-height: ${lineHeight.title};

  @media ${device.mobileL} {
    font-size: ${fontSize[18]};
  }
`

const StyledSmallText = styled(SmallText)`
  display: block;
  color: ${color.spaceMedium};
`

function PricePerTicket({ t, price }) {
  return (
    <Pricing>
      <Price money={price} />
      <StyledSmallText>/ {t('common:generic.ticket')}</StyledSmallText>
    </Pricing>
  )
}

export default PricePerTicket
